<aside class="sidebar" [class.sidebar-expanded]="expanded" aria-label="Main navigation">
  <div class="sidebar-header">
    <span class="sidebar-brand" *ngIf="expanded">BestRoute</span>
    <button type="button" class="br-interactive view-tab sidebar-toggle" (click)="toggleSidebar()"
            [attr.aria-label]="expanded ? 'Collapse sidebar' : 'Expand sidebar'"
            [attr.aria-expanded]="expanded" [matTooltip]="expanded ? 'Collapse sidebar' : 'Expand sidebar'">
      <br-icon>{{ expanded ? 'menu_open' : 'menu' }}</br-icon>
    </button>
  </div>

  <div class="sidebar-scroll">
    <nav class="business-navigation" aria-label="Business navigation">
      <button type="button" class="br-interactive view-tab" aria-label="Dashboard" matTooltip="Dashboard" [matTooltipDisabled]="expanded"
              [attr.aria-current]="activeViewTab === 'dashboard' ? 'page' : null" (click)="onViewTabClick('dashboard')">
        <br-icon>auto_awesome_mosaic</br-icon><span class="nav-label">Dashboard</span>
      </button>
      <button type="button" class="br-interactive view-tab" aria-label="Business Insight" matTooltip="Business Insight" [matTooltipDisabled]="expanded"
              [attr.aria-current]="activeViewTab === 'overview' ? 'page' : null" (click)="onViewTabClick('overview')">
        <br-icon>home</br-icon><span class="nav-label">Business Insight</span>
      </button>
      <button *ngIf="auth.hasPermission('LeadWorkItem.View')" type="button" class="br-interactive view-tab"
              aria-label="Campaigns" matTooltip="Campaigns" [matTooltipDisabled]="expanded"
              [attr.aria-current]="activeViewTab === 'campaigns' ? 'page' : null" (click)="onViewTabClick('campaigns')">
        <br-icon>campaign</br-icon><span class="nav-label">Campaigns</span>
      </button>
      <button type="button" class="br-interactive view-tab" *ngIf="auth.hasPermission('File.View')" aria-label="Files" matTooltip="Files" [matTooltipDisabled]="expanded"
              [attr.aria-current]="activeViewTab === 'files' ? 'page' : null" (click)="onViewTabClick('files')">
        <br-icon>folder</br-icon><span class="nav-label">Files</span>
      </button>
    </nav>

    <app-map-layer-menu [compact]="!expanded"></app-map-layer-menu>

    <div class="conversation-shortcuts" *ngIf="!expanded">
      <button type="button" class="br-interactive view-tab" aria-label="New conversation"
              matTooltip="New conversation" (click)="convo.newConversation()">
        <br-icon>chat_bubble_outline</br-icon>
      </button>
      <button type="button" class="br-interactive view-tab conversation-history-shortcut"
              [attr.aria-label]="convo.persistenceError ? 'Conversations — not synced' : 'Conversations'"
              [matTooltip]="convo.persistenceError ? 'Conversations — not synced' : 'Conversations'" (click)="showConversations()">
        <br-icon>forum</br-icon>
        <span class="conversation-sync-dot" *ngIf="convo.persistenceError" aria-hidden="true"></span>
      </button>
    </div>

    <section class="conversation-list" *ngIf="expanded" aria-label="Conversations">
      <div class="sidebar-section-title">
        <span>Conversations</span>
        <button type="button" class="br-interactive view-tab new-conversation" aria-label="New conversation"
                matTooltip="New conversation" (click)="convo.newConversation()">
          <br-icon>chat_bubble_outline</br-icon>
        </button>
      </div>
      <div role="status" *ngIf="convo.persistenceError">
        <button type="button" class="br-interactive conversation-sync-retry"
                [matTooltip]="convo.persistenceError" [attr.aria-label]="convo.persistenceError + ' Retry syncing conversation.'"
                (click)="convo.retryPersistence()">
          <br-icon aria-hidden="true">cloud_off</br-icon>
          <span>Not synced · Retry</span>
        </button>
      </div>
      <div class="br-interactive conversation-row" *ngFor="let conversation of convo.conversations"
           [class.br-interactive--selected]="conversation.id === convo.activeConversation.id">
        <input *ngIf="editingConversationId === conversation.id; else conversationButton"
               class="conversation-rename br-form-control" aria-label="Conversation name"
               [value]="conversation.title" #nameInput maxlength="100"
               (blur)="finishRename(conversation.id, nameInput.value)"
               (keydown.enter)="finishRename(conversation.id, nameInput.value); $event.preventDefault()"
               (keydown.escape)="editingConversationId = null; $event.preventDefault()">
        <ng-template #conversationButton>
          <button type="button" class="br-focus-ring conversation-link" (click)="convo.selectConversation(conversation.id)"
                  [attr.aria-current]="conversation.id === convo.activeConversation.id ? 'true' : null"
                  [matTooltip]="conversation.title">
            <span class="conversation-title">{{ conversation.title }}</span>
            <span class="conversation-working" *ngIf="convo.isWorking(conversation)" aria-label="Working"></span>
          </button>
          <button type="button" class="conversation-menu" [brMenuTriggerFor]="conversationMenu"
                  [attr.aria-label]="'Options for ' + conversation.title">
            <br-icon>more_horiz</br-icon>
          </button>
          <ng-template #conversationMenu>
            <br-menu aria-label="Conversation actions">
              <button brMenuItem [disabled]="conversation.archiving" (triggered)="startRename(conversation.id)" label="Rename" icon="edit"></button>
              <button brMenuItem [disabled]="conversation.archiving || conversation.saving || conversation.clearing"
                      (triggered)="convo.setArchived(conversation.id, true)" label="Archive" icon="archive"></button>
            </br-menu>
          </ng-template>
        </ng-template>
      </div>
      <span role="status" *ngIf="convo.loadingHistory">Loading conversations…</span>
      <button type="button" class="br-btn br-btn--sm" *ngIf="convo.nextHistoryOffset !== null"
              [disabled]="convo.loadingHistory" (click)="convo.loadHistory(true)">Load more</button>
    </section>
  </div>
  <ng-container *ngIf="auth.isAuthenticated(); else signIn">
    <button type="button"
            class="br-interactive sidebar-account"
            [brMenuTriggerFor]="accountMenu"
            aria-label="Account"
            matTooltip="Account">
      <span class="account-avatar">{{ accountInitials() }}</span>
      <span class="nav-label">{{ accountEmail() }}</span>
    </button>
    <ng-template #accountMenu>
      <br-menu aria-label="Account">
        <div class="account-menu-email">{{ accountEmail() }}</div>
        <button brMenuItem (triggered)="openConfiguration()" label="Configuration" icon="settings"></button>
        <button brMenuItem (triggered)="logout()" label="Log out" icon="logout"></button>
      </br-menu>
    </ng-template>
  </ng-container>
  <ng-template #signIn>
    <button type="button"
            class="br-interactive view-tab sidebar-bottom"
            (click)="goToLogin()"
            aria-label="Sign in"
            matTooltip="Sign in">
      <br-icon>login</br-icon><span class="nav-label">Sign in</span>
    </button>
  </ng-template>
</aside>
